export * from './keywords';

export enum TSpeakerMode {
    SINGLE = '0',
    MULTI = '1'
}

export interface ISpeakerAiScore {
    speaker_id: string;
    speaker_name: string;
    gesture: string;
    speed: string;
    smile: string;
    volume: string;
    smooth: string;
    sight: string;
    ai_average_score: string;
}

export interface ISpeakerSpeed {
    speaker_id: string;
    speaker_name: string;
    avg: string;
}

export interface ISpeakerVolume {
    speaker_id: string;
    speaker_name: string;
    avg: string;
}

export interface ISpeaker {
    speaker_id: string;
    speaker_name: string;
}

export interface IAIWeight {
    weight: number;
}

export interface IAILabel {
    gesture: IAIWeight;
    sight: IAIWeight;
    smile: IAIWeight;
    smooth: IAIWeight;
    speed: IAIWeight;
    volume: IAIWeight;
}

export interface IAIExpressiveEvalTemp {
    id: number;
    name: string;
    type: number;
    ai_label: IAILabel;
}
export enum EAsrType {
    UASR = 1,
    Ami = 7,
    Microsoft = 6,
}
